import { API_URL } from "@/lib/api";
import { fmtDate, nok, num } from "@/lib/format";

/** Public PDF for the same immutable version the token points at. */
export const publicPdfUrl = (token) => `${API_URL}/public/quotes/${token}/pdf`;

/** Proposal state → label + tone. `open` is the only state where acceptance is possible. */
export const stateMeta = (data) => {
  const q = data?.quote || {};
  switch (data?.state) {
    case "accepted":
      return { label: `Akseptert ${fmtDate(data.response?.accepted?.created_at || q.accepted_at)}`, tone: "success", short: "Akseptert" };
    case "declined":
      return { label: "Tilbudet er avsluttet", tone: "danger", short: "Avslått" };
    case "preview":
      return { label: "Forhåndsvisning – utkast", tone: "warning", short: "Utkast" };
    case "superseded":
      return { label: `Erstattet av versjon ${q.current_version}`, tone: "neutral", short: "Erstattet" };
    case "lapsed":
      return { label: `Gyldighet utløp ${fmtDate(q.valid_until)}`, tone: "warning", short: "Utløpt" };
    default:
      return { label: `Gyldig til ${fmtDate(q.valid_until)}`, tone: "success", short: "Gjeldende" };
  }
};

export const TONE_DOT = {
  success: "bg-emerald-400",
  warning: "bg-amber-400",
  danger: "bg-rose-400",
  neutral: "bg-slate-300",
};

/** "12 stk × 24 mnd" – quantity/unit/months for a price line, without repeating the unit price. */
export const qtyLabel = (l) => {
  const qty = num(l.quantity, 2);
  if (l.unit === "mnd") return l.months ? `${qty} stk × ${num(l.months, 1)} mnd` : `${qty} mnd`;
  return `${qty} ${l.unit || ""}`.trim();
};

export const unitPriceLabel = (l) => {
  if (l.sell_unit == null) return "";
  const per = l.unit === "mnd" ? "/mnd" : l.unit ? `/${l.unit}` : "";
  return `${nok(l.sell_unit)}${per}`;
};

/** Split free text into paragraphs (double or single newlines). */
export const paragraphs = (text) => String(text || "").split(/\n+/).map((p) => p.trim()).filter(Boolean);

export const initialsOf = (name = "") => name.split(" ").filter(Boolean).slice(0, 2).map((s) => s[0]?.toUpperCase()).join("");

export const SECTIONS = [
  { id: "losning", label: "Løsning" },
  { id: "leveranse", label: "Leveranse" },
  { id: "pris", label: "Pris" },
  { id: "vilkar", label: "Vilkår" },
  { id: "svar", label: "Svar" },
];

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};
